import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.registriere-push-notification';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRegistrierePushNotificationEffects {

    RegistrierePushNotification$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_REGISTRIERE_PUSH_NOTIFICATION),
        mergeMap((x: ac.PostRegistrierePushNotificationAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRegistrierePushNotification(x.benutzerPushNotificationRequest).pipe(
                map((result: any) => {
                    return new ac.PostRegistrierePushNotificationErfolgreichAction(result, x.benutzerPushNotificationRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRegistrierePushNotificationFehlerAction(error, x.benutzerPushNotificationRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungCommandService);
        }
        return this.service;
    }
}
